export const L10N = {
  LABEL_OUR_BEST_ONLINE_RATE: { id: 'core.label.our_best_online_rate' },
};
